import React, { Component } from "react";
import { Modal } from "react-responsive-modal";
import { default as ReactSelect } from "react-select";
import { Icon } from "@iconify/react";
import { withNamespaces } from "react-i18next";
import ReactPinField from "react-pin-field";

import NumberInput from "../../components/Input/NumberInput/NumberInput";
import StringInput from "../../components/Input/StringInput/StringInput";
import PasswordInput from "../../components/Input/PasswordInput/PasswordInput";

import ValidationError from "../../components/ValidationError/ValidationError";
import Button from "../../components/Button/Button";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

// const options = [
//   { value: "malaysia", label: "Malaysia +60" },
//   { value: "singapo", label: "Singapo +60" },
//   { value: "china", label: "China +60" },
// ];

export class EditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,

            showPaymentNew_pass: false,
            showPaymentOld_pass: false,
            showPaymentConfirm_pass: false,

            showLoginNew_pass: false,
            showLoginOld_pass: false,
            showLoginConfirm_pass: false,

            current_password: "",
            new_password: "",
            confirm_password: "",
        };
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption }, () => console.log(`Option selected:`, this.state.selectedOption));
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    render() {
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const flags = this.imageImport(require.context("../../assets/images/flags/", false, /\.(png|jpe?g|svg|webp)$/));

        const { t } = this.props;

        const ChangePasswordSchema = Yup.object().shape({
            current_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required")),
            new_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required")),
            confirm_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required"))
                .when("new_password", {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
                }),
        });

        const ChangePaymentPasswordSchema = Yup.object().shape({
          current_payment_password: Yup.string()
              .min(6, t("validation.minLength", { 0: 6 }))
              .max(20, t("validation.maxLength", { 0: 20 }))
              .required(t("validation.required")),
          new_payment_password: Yup.string()
              .min(6, t("validation.minLength", { 0: 6 }))
              .max(20, t("validation.maxLength", { 0: 20 }))
              .required(t("validation.required")),
          confirm_payment_password: Yup.string()
              .min(6, t("validation.minLength", { 0: 6 }))
              .max(20, t("validation.maxLength", { 0: 20 }))
              .required(t("validation.required"))
              .when("new_password", {
                  is: (val) => (val && val.length > 0 ? true : false),
                  then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
              }),
      });

      const SetPaymentPasswordSchema = Yup.object().shape({
        new_payment_password: Yup.string()
            .min(6, t("validation.minLength", { 0: 6 }))
            .max(20, t("validation.maxLength", { 0: 20 }))
            .required(t("validation.required")),
        confirm_payment_password: Yup.string()
            .min(6, t("validation.minLength", { 0: 6 }))
            .max(20, t("validation.maxLength", { 0: 20 }))
            .required(t("validation.required"))
            .when("new_password", {
                is: (val) => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
            }),
    });
        return (
            <Modal open={this.props.openEditModal} onClose={this.props.toggleEditModal} classNames={{ modal: "pd-edit-modal global-modal" }} center>
                <div className="modal-content">
                    {this.props.editModalContent === "real_name" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.edit")} {t("personal-details.real-name")}</h4>
                            </div>
                            <div className="modal-body">
                                <form
                                    className="forms-col needs-validation"
                                    onSubmit={this.props.updateAgentName}
                                    noValidate
                                    id="edit_real_name_form"
                                    name="edit_real_name_form"
                                    method="post"
                                >
                                    <div className="mb-3">
                                        <label>{t("personal-details.real-name")}</label>
                                        <StringInput
                                            className={`form-control ${this.props.errorMsg.name && "was-validated is-invalid"}`}
                                            // className="form-control"
                                            type="text"
                                            placeholder={t("personal-details.real-name")}
                                            name="realName"
                                            defaultValue=""
                                            value={this.props.personalInfo.real_name}
                                            onChange={(e) => this.props.enterRealName(e)}
                                            autoComplete="off"
                                            // minLength={contact_no_min_limits}
                                            // maxLength={contact_no_max_limits}
                                            // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                            // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                            required
                                            requiredMessage={t("validation.required")}
                                            // errorMsg={this.props.errorMsg.mobile_no || ""}
                                            // formError={this.props.formError}
                                        />
                                    </div>
                                    <button
                                        className={`btn btn-gradient-blue w-75 mx-auto ${this.props.personalInfo.real_name === "" ? `disabled` : ``}`}
                                        type="submit"
                                        form="edit_real_name_form"
                                    >
                                        {t("global.confirm")}
                                    </button>
                                </form>
                            </div>
                        </>
                    ) : this.props.editModalContent === "mobile_no" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("profile.edit-mobile-number")}</h4>
                                <small>
                                    {t("profile.verification-mention-1")}
                                    {t("global.customer-service")}
                                    {t("profile.verification-mention-2")}
                                </small>
                            </div>
                            <div className="modal-body">
                                <form className="forms-col needs-validation" noValidate onSubmit={(e) => this.props.verifyOtpHandler(e)}>
                                    <div className="input-group left has-validation">
                                        <ReactSelect
                                            classNamePrefix="react-select"
                                            defaultValue={this.props.countryArry[0]}
                                            // value={this.state.selectedOption}
                                            onChange={this.handleChange}
                                            options={this.props.countryArry}
                                            formatOptionLabel={(item) => (
                                                <>
                                                  <img src={flags[`${item.code}.webp`]} alt={item.image} />
                                                  <p>{item.label}</p>
                                                </>
                                              )}
                                        />

                                        <StringInput
                                            className={`${this.props.errorMsg.contact_no && "was-validated is-invalid"}`}
                                            type="text"
                                            placeholder={t("profile.mobile-phone-no")}
                                            name="verificationMobileNo"
                                            defaultValue=""
                                            value={this.props.currentMobileNo}
                                            onChange={(e) => this.props.enterMobileNumber(e)}
                                            minLength={this.props.contactNoMinLimits}
                                            maxLength={this.props.contactNoMaxLimits}
                                            minLengthMessage={t("validation.minLength", { 0: this.props.contactNoMinLimits })}
                                            maxLengthMessage={t("validation.maxLength", { 0: this.props.contactNoMaxLimits })}
                                            required
                                            requiredMessage={t("validation.required")}
                                            errorMsg={this.props.errorMsg.contact_no || ""}
                                            formError={this.props.formError}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <NumberInput
                                            className={`form-control forget-pwd-mobile ${this.props.errorMsg.otp_code && "was-validated is-invalid"}`}
                                            // className={`form-control forget-pwd-mobile`}
                                            type="number"
                                            onChange={(e) => this.props.enterMobileVarificationCode(e)}
                                            placeholder={t("profile.enter-verification-code")}
                                            errorMsg={this.props.errorMsg.otp_code || ""}
                                            formError={this.props.formError}
                                            required
                                            requiredMessage={t("validation.required")}
                                            value={this.props.mobileVarificationCode}
                                        />
                                        {/* <div className="invalid-feedback">
                                            <Icon icon="akar-icons:circle-alert-fill" />
                                            {this.props.errorMsg.otp_code} 
                                        </div> */}
                                        {this.props.generateOTPStatus && this.props.check_sending_sms_status ? (
                                            <div className="d-flex align-items-center justify-content-between">
                                                <small>
                                                    {t("top-profile.otp-attempt-msg")} {this.props.check_sending_sms_times} / 5
                                                </small>
                                                <Button
                                                    typeButton="button"
                                                    clicked={(event) => this.props.resendOTPHandler(event)}
                                                    classValue="btn btn-underlined"
                                                    buttonName={this.props.resendOTPCountDownTimer}
                                                    disabled={this.props.resend_otp_button_disabled === true ? true : false}
                                                />
                                            </div>
                                        ) : (
                                            <button className="btn btn-underlined" onClick={(e) => this.props.generateOTPHandler(e)}>
                                                 {t("profile.get-verification-code")}
                                            </button>
                                        )}
                                    </div>
                                    <button className="btn btn-gradient-blue w-75 mx-auto" type="submit" disabled={this.props.mobileVarificationCode === "" ? true : false}>
                                        {t("global.submit")}
                                    </button>
                                </form>
                            </div>
                        </>
                    ) : this.props.editModalContent === "email" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("profile.edit-email-address")}</h4>
                                <small>
                                    {t("profile.verification-mention-1")}
                                    {t("global.customer-service")}
                                    {t("profile.verification-mention-2")}
                                </small>
                            </div>
                            <div className="modal-body">
                                <form
                                    className="forms-col needs-validation"
                                    onSubmit={this.props.verifyEmail}
                                    name="email_verification_from"
                                    id="email_verification_from"
                                    method="post"
                                    noValidate
                                >
                                    <ValidationError formName="email_verification_from" touched={this.props.touched} message={this.props.errorMsg} />

                                    <div>
                                        <StringInput
                                            // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                            className="form-control"
                                            type="email"
                                            placeholder={t("profile.email-address")}
                                            name="emailAddress"
                                            defaultValue=""
                                            value={this.props.email}
                                            onChange={(e) => this.props.enterEmail(e)}
                                            // minLength={contact_no_min_limits}
                                            // maxLength={contact_no_max_limits}
                                            // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                            // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                            required
                                            requiredMessage={t("validation.required")}
                                            errorMsg={this.props.errorMsg.email || ""}
                                            // formError={this.props.formError}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <NumberInput
                                            // className={`form-control forget-pwd-mobile ${this.props.errorMsg.otp_code && "was-validated is-invalid"}`}
                                            className={`form-control`}
                                            type="number"
                                            onChange={(e) => this.props.enterEmailVarificationCode(e)}
                                            placeholder={t("profile.enter-verification-code")}
                                            errorMsg={this.props.errorMsg.otp_code || ""}
                                            // formError={this.props.formError}
                                            required
                                            requiredMessage={t("validation.required")}
                                            value={this.props.emailVarificationCode}
                                        />
                                        {/* <input
                        className={`form-control ${this.props.emailVarificationCode === "" ? "is-invalid is-invalid" : "is-valid is-valid"}`}
                        value={this.props.emailVarificationCode}
                        placeholder='Please enter verification code'
                        onChange={(e) => this.props.enterEmailVarificationCode(e)}
                      /> */}
                                      
                                        <button className="btn btn-underlined" onClick={this.props.generateEmailOTP}>
                                            {t("profile.get-verification-code")}
                                        </button>
                                    </div>
                                    <button className="btn btn-gradient-blue w-75 mx-auto" type="submit">
                                            {t("global.submit")}
                                    </button>
                                </form>
                            </div>
                        </>
                    ) : this.props.editModalContent === "payment_pass" || this.props.verifyPaymentPasswordStatus === true ? (
                        <>
                            <div className="modal-header">
                            {this.props.contactVerifiedStatus === 1 && (
                                <>
                                <h4 className="modal-title">{t("personal-details.set-new-payment-password")}</h4>
                                <div>
                                    <small>{t("profile.security-pin-desc")}</small>
                                </div>
                                </>
                                )}
                            </div>
                            
                            <div className="modal-body text-center">
                            <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.setPaymentPasswordHandler(e)}>
                                {this.props.contactVerifiedStatus === 1 && (
                                    <ReactPinField
                                        className="pin-field"
                                        length="6"
                                        validate="0123456789"
                                        type="password"
                                        value={this.props.payment_password}
                                        onComplete={this.props.onInputChange}
                                    />
                                )}

                                {this.props.contactVerifiedStatus === 0 && (
                                    <>
                                        <div className="d-block lh-1 mt-3">{t("profile.security-pin-verify-mobile-no")}</div>

                                        <button className="btn btn-gradient-blue w-75 mx-auto" type="button" 
                                        // onClick={() => this.props.toggleEditModal("mobile_no")}
                                        >
                                            {t("profile.verify-mobile-number")}
                                    </button>
                                    </>
                                )}

                                {this.props.contactVerifiedStatus === 1 && (
                                    <>
                                        <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                            {t("global.submit")}
                                        </button>
                                   </>
                                )}

                            </form>
                            </div>

                          
                        </>
                    ) : this.props.editModalContent === "update_payment_password" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.edit-payment-password")}</h4>
                                <div>
                                    <small>{t("profile.security-pin-desc")}</small>
                                </div>
                            </div>
                            <div className="modal-body text-center">
                            <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.onEditPaymentPasswordHandler(e)}>
                                {this.props.contactVerifiedStatus === 1 && (
                                    <ReactPinField
                                        className="pin-field"
                                        length="6"
                                        validate="0123456789"
                                        type="password"
                                        value={this.props.payment_password}
                                        onComplete={this.props.onInputChange}
                                    />
                                )}

                                {this.props.contactVerifiedStatus === 1 && (
                                    <>
                                        <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                            {t("global.submit")}
                                        </button>
                                        <button className="btn btn-underlined" type="button" onClick={() => this.props.onForgetPaymentPasswordHandler()}>
                                        <small>{t("profile.forget-security-pin")}</small>
                                    </button>
                                   </>
                                )}

                                
                            </form>
                            </div>

                          
                        </>
                    ): this.props.editModalContent === "remove_payment_password" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.remove-payment-password")}</h4>
                                <div>
                                    <small>{t("profile.security-pin-desc")}</small>
                                </div>
                            </div>
                            <div className="modal-body text-center">
                            <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.onRemovePaymentPasswordHandler(e)}>
                                {this.props.contactVerifiedStatus === 1 && (
                                    <ReactPinField
                                        className="pin-field"
                                        length="6"
                                        validate="0123456789"
                                        type="password"
                                        value={this.props.payment_password}
                                        onComplete={this.props.onInputChange}
                                    />
                                )}

                                  {this.props.contactVerifiedStatus === 1 && (
                                    <>
                                        <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                            {t("global.submit")}
                                        </button>
                                        <button className="btn btn-underlined" type="button" onClick={() => this.props.onForgetPaymentPasswordHandler()}>
                                        <small>{t("profile.forget-security-pin")}</small>
                                    </button>
                                   </>
                                )}

                                
                            </form>
                            </div>

                          
                        </>
                    ) : this.props.editModalContent === "login_pass" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.edit-login-password")}</h4>
                            </div>
                            <div className="modal-body">
                                <Formik
                                    innerRef={(p) => (this.formik = p)}
                                    initialValues={{
                                        current_password: "",
                                        new_password: "",
                                        confirm_password: "",
                                    }}
                                    validationSchema={ChangePasswordSchema}
                                    onSubmit={(values, actions) => {
                                        this.props.updateLoginPasswordHandler(values, actions);
                                    }}
                                >
                                    {({ errors, touched }) => (
                                        <Form
                                            className="forms-col"
                                            // method="post"
                                            name="change_password_from"
                                            id="change_password_from"
                                            // onSubmit={this.updateLoginPasswordHandler}
                                            noValidate
                                        >
                                            {/* <ValidationError formName="change_password_from" touched={this.state.touched} message={this.state.errorMsg} /> */}
                                            <div>
                                                <label className="col-form-label lh-1">{t("profile.old-password")}</label>
                                                <div className="input-group right has-validation">
                                                    {this.props.errorMsg.current_password || touched.current_password ? (
                                                        <Field
                                                            name="current_password"
                                                            type={`${!this.state.showOldPwd ? "password" : "text"}`}
                                                            className={`form-control ${
                                                                this.props.errorMsg.current_password || (touched.current_password && errors.current_password)
                                                                    ? `is-invalid`
                                                                    : `is-valid`
                                                            }`}
                                                            minLength="8"
                                                            maxLength="20"
                                                            onKeyUp={(e) => this.props.enterLoginOldPass(e)}
                                                        />
                                                    ) : (
                                                        <Field name="current_password" type="password" className={`form-control`} minLength="8" maxLength="20" />
                                                    )}
                                                    <span className="input-group-text">
                                                        <button
                                                            type="button"
                                                            className="btn icon"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showOldPwd: !this.state.showOldPwd,
                                                                })
                                                            }
                                                        >
                                                            {this.state.showOldPwd ? <Icon icon="ph:eye" /> : <Icon icon="ph:eye-closed" />}
                                                        </button>
                                                    </span>
                                                    {(this.props.errorMsg.current_password || (touched.current_password && errors.current_password)) && (
                                                        <div className="invalid-feedback">
                                                            {errors.current_password ? errors.current_password : this.props.errorMsg.current_password}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="col-form-label lh-1">{t("profile.new-password")}</label>
                                                <div className="input-group right has-validation">
                                                    {this.props.errorMsg.new_password || touched.new_password ? (
                                                        <Field
                                                            name="new_password"
                                                            type={`${!this.state.showPwd ? "password" : "text"}`}
                                                            className={`form-control ${
                                                                this.props.errorMsg.new_password || (touched.new_password && errors.new_password) ? `is-invalid` : `is-valid`
                                                            }`}
                                                            minLength="8"
                                                            maxLength="20"
                                                            onKeyUp={(e) => this.props.enterLoginNewPass(e)}
                                                        />
                                                    ) : (
                                                        <Field name="new_password" type="password" className={`form-control`} minLength="8" maxLength="20" />
                                                    )}

                                                    <span className="input-group-text">
                                                        <button
                                                            type="button"
                                                            className="btn icon"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showPwd: !this.state.showPwd,
                                                                })
                                                            }
                                                        >
                                                            {this.state.showPwd ? <Icon icon="ph:eye" /> : <Icon icon="ph:eye-closed" />}
                                                        </button>
                                                    </span>
                                                    {(this.props.errorMsg.new_password || (touched.new_password && errors.new_password)) && (
                                                        <div className="invalid-feedback">{errors.new_password ? errors.new_password : this.props.errorMsg.new_password}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="col-form-label lh-1">{t("profile.confirm-password")}</label>
                                                <div className="input-group right has-validation">
                                                    {this.props.errorMsg.confirm_password || touched.confirm_password ? (
                                                        <Field
                                                            name="confirm_password"
                                                            type={`${!this.state.showPwdConfirmation ? "password" : "text"}`}
                                                            className={`form-control ${
                                                                this.props.errorMsg.confirm_password || (touched.confirm_password && errors.confirm_password)
                                                                    ? `is-invalid`
                                                                    : `is-valid`
                                                            }`}
                                                            minLength="8"
                                                            maxLength="20"
                                                            onKeyUp={(e) => this.props.enterLoginConfirmPass(e)}
                                                        />
                                                    ) : (
                                                        <Field name="confirm_password" type="password" className={`form-control`} minLength="8" maxLength="20" />
                                                    )}
                                                    <span className="input-group-text">
                                                        <button
                                                            type="button"
                                                            className="btn icon"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showPwdConfirmation: !this.state.showPwdConfirmation,
                                                                })
                                                            }
                                                        >
                                                            {this.state.showPwdConfirmation ? <Icon icon="ph:eye" /> : <Icon icon="ph:eye-closed" />}
                                                        </button>
                                                    </span>
                                                    {(this.props.errorMsg.confirm_password || (touched.confirm_password && errors.confirm_password)) && (
                                                        <div className="invalid-feedback">
                                                            {errors.confirm_password ? errors.confirm_password : this.props.errorMsg.confirm_password}
                                                        </div>
                                                    )}
                                                    {/* {touched.confirm_password} | {errors.confirm_password} | {this.state.errorMsg.confirm_password} */}
                                                </div>
                                            </div>

                                            <button className="btn btn-gradient-blue w-75 mx-auto" type="submit">
                                                {t("global.submit")}
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </Modal>
        );
    }
}

export default withNamespaces()(EditModal);
